import React from "react";
import styles from "./weather-widget.module.scss";
import { WeatherCloudySunIcon, WeatherRainyIcon } from "../../../../../assets/icons";

export const WeatherWidget: React.FC = () => {
	return (
		<div className={styles.card}>
			<div className={styles.infoBox}>
				<div className={styles.dayColumn}>
					<span className={styles.dayLabel}>Today</span>
					<div className={styles.weatherRow}>
						<span className={styles.weatherIcon}>
							<WeatherCloudySunIcon />
						</span>
						<span className={styles.temperature}>18°</span>
					</div>
				</div>
				<div className={styles.dayColumn}>
					<span className={styles.dayLabel}>Tomorrow</span>
					<div className={styles.weatherRow}>
						<span className={styles.weatherIcon}>
							<WeatherRainyIcon />
						</span>
						<span className={styles.temperature}>Rain</span>
					</div>
				</div>
			</div>
		</div>
	);
};
